import React from 'react'
import { Route, Switch } from 'react-router-dom'
import LmsHubConnect from '../lms-hub-connect'

const PublicRoutes = () => (
  <Switch>
    <Route path="/lms-hub-connect" component={LmsHubConnect} />
  </Switch>
)

export default PublicRoutes
